module.exports = __webpack_public_path__ + "img/next.e5a6f864.png";